import { render, staticRenderFns } from "./SendIndicationsPhoto.vue?vue&type=template&id=2b4863a7&"
import script from "./SendIndicationsPhoto.vue?vue&type=script&lang=js&"
export * from "./SendIndicationsPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports